import { RouteRecordRaw } from "vue-router";

const hdaRoutes: RouteRecordRaw = {
  path: "/hda",
  component: () => import(/* webpackChunkName: "SimpleLayout" */ "../layouts/SimpleLayout.vue"),
  redirect: { name: "collaborator" },
  meta: { title: "HDA" },

  children: [
    {
      path: "",
      component: () => import(/* webpackChunkName: "HdaWrapper" */ "../layouts/HdaWrapper.vue"),
      children: [
        {
          path: "collaborator",
          name: "collaborator",
          component: () => import(/* webpackChunkName: "collaborator" */ "../views/CollaboratorView.vue"),
        },
        {
          path: "economic",
          name: "economic",
          component: () => import(/* webpackChunkName: "economic" */ "../views/EconomicExplotationView.vue"),
        },
        {
          path: "explotation",
          name: "explotation",
          component: () => import(/* webpackChunkName: "explotation" */ "../views/ExplotationView.vue"),
        },
        {
          path: "individualDetails/:id",
          name: "individualDetails",
          component: () => import(/* webpackChunkName: "individual" */ "../views/IndividualDetailsView.vue"),
        },
      ],
    },
  ],
};

export default hdaRoutes;
